import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatProgressBar } from "@angular/material/progress-bar";
import type { InterruptItem } from "../../../model/interrupt.types";
import { NotificationCardComponent } from "../../shared/notification-card/notification-card.component";

/**
 * HITL card shown during frontend_tools execution.
 * Blocks the UI while the agent waits for the browser to execute tool calls.
 */
@Component({
  selector: "app-hitl-tool-call-card",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatProgressBar, NotificationCardComponent],
  templateUrl: "./hitl-tool-call-card.component.html",
})
export class HitlToolCallCardComponent {
  displayText = input.required<string>();

  items = input<InterruptItem[]>([]);

  protected readonly toolNames = computed(() =>
    this.items()
      .filter((i) => i.kind === "tool_call")
      .map((i) => i.tool_name.replace(/_/g, " ")),
  );
}
